import { useInfiniteQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { getNextPageParamFromPaginatedResult } from '@/api/infiniteQueries';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';

const GET_CHAT_AGENT_CONVERSATIONS = graphql(`
  query GetChatAgentConversations($pagination: PaginationInput!) {
    me {
      chatAgentConversations(pagination: $pagination) {
        items {
          id
          title
          summary
        }
        totalCount
        offset
        limit
      }
    }
  }
`);

const useGetChatAgentConversations = () => {
  const queryFn = ({ pageParam }: { pageParam: number }) => {
    return gqlClient.request(GET_CHAT_AGENT_CONVERSATIONS, {
      pagination: {
        offset: pageParam,
        limit: PAGINATION_ARG_DEFAULTS.limit,
      },
    });
  };

  const { data, ...rest } = useInfiniteQuery({
    queryKey: meKeys.chatAgentConversations(),
    queryFn,
    initialPageParam: PAGINATION_ARG_DEFAULTS.offset,
    getNextPageParam: getNextPageParamFromPaginatedResult(
      (lastPage) => lastPage.me.chatAgentConversations
    ),
  });

  const chatAgentConversations = data?.pages.flatMap(
    (page) => page.me.chatAgentConversations.items
  );

  return {
    data,
    chatAgentConversations,
    ...rest,
  };
};

export default useGetChatAgentConversations;
